module.exports = {
	"apertureWidth": "조준창 폭",
	"apertureLength": "조준창 길이",
	"apertureGap1": "조준창 간격 1",
	"apertureGap2": "조준창 간격 2",
	"ballDiameter": "볼 지름",
	"bodyOffset": "본체 간격띄우기",
	"bodyLength": "본체 길이",
	"bodyDiameter": "본체 지름",
	"bodyHeight": "본체 높이",
	"bodyColor": "본체 색상",
	"componentFamily": "구성요소 패밀리",
	"colPitch": "열 피치",
	"chipArrayNote": "* L1 및 b1은 선택 사항입니다.",
	"crystalNote": "* (D, D2, L)에서 선택적 치수를 선택합니다. 서로 다른 조합으로 다양한 외곽설정 패드 크기를 생성할 수 있습니다.",	
	"densityLevel": "밀도 수준",	
	"femaleStandoffNote": "* 마운팅 구멍 패드는 선택 사항이며 왼쪽 이미지에 표시된 치수의 값을 입력하여 생성할 수 있습니다. 구멍 지름(b)은 내부 스레딩 없는 스페이서 기계 모형 및 마운팅 구멍 생성에 사용됩니다.",
	"footprintOrigin": "외곽설정 원점",
	"hPinPitch": "수평 핀 피치",
	"hTerminalGap": "수평 터미널 간격",
	"hTerminalTailLength": "수평 터미널 가로선 길이",
	"innerThreadDepth": "내부 스레드 깊이",
	"innerThreadSize": "내부 스레드 크기",
	"innerThreadDesignation": "내부 스레드 지정",
	"leadDiameter": "리드 지름",
	"leadSpan": "리드 스팬",
	"leadSpan1": "리드 스팬 1",
	"leadSpan2": "리드 스팬 2",
	"leadShape": "리드 쉐이프",
	"largerTerminalLength": "더 큰 터미널 길이",
	"largerTerminalWidth": "더 큰 터미널 폭",
	"maleFemaleStandoffNote": "* 마운팅 구멍 패드는 선택 사항이며 왼쪽 이미지에 표시된 치수의 값을 입력하여 생성할 수 있습니다. 구멍 지름(b)은 마운팅 구멍 생성에 사용됩니다.",
	"mapSilkscreen": "실크스크린을 본체에 매핑",
	"optionalDimensionNote": "* (D, D2, L)에서 선택적 치수를 선택합니다. 서로 다른 조합으로 다양한 외곽설정 패드 크기를 생성할 수 있습니다.",
	"oddTerminalLength": "홀수 터미널 길이",
	"oddTerminalWidth": "홀수 터미널 폭",
	"optionalDimension": "선택적 치수",	
	"partialThread": "부분 스레드",	
	"pasteCoverage": "커버리지 붙여넣기",
	"producibilityLevel": "생산 가능 수준",
	"pinPitch": "핀 피치",
	"padToHoleRatio": "패드 대 구멍 비율",
	"padRoundness": "패드 둥글기",
	"pinNumbering": "핀 번호 매기기",
	"postLength": "기둥 길이",
	"postThreadSize": "기둥 스레드 크기",
	"postThreadDesignation": "기둥 스레드 지정",
	"rowPitch": "행 피치",
	"tabWidth": "탭 폭",
	"tabLength": "탭 길이",
	"terminalThickness": "터미널 두께",
	"terminalWidth": "터미널 폭",
	"terminalLength": "터미널 길이",
	"terminalGap": "터미널 간격",
	"terminalCCGap": "터미널 중심-중심 간격",
	"terminalCCGap1": "터미널 중심-중심 간격 1",
	"terminalCCGap2": "터미널 중심-중심 간격 2",
	"terminalTailLength": "터미널 가로선 길이",
	"terminalPostLength": "터미널 기둥 길이",
	"terminalType": "터미널 유형",	
	"threadDepth": "스레드 깊이",
	"threadSize": "스레드 크기",
	"threadDesignation": "스레드 지정",	
	"threaded": "스레드",
	"truncateMiddlePin": "중간 핀 자르기",		
	"vPinPitch": "수직 핀 피치",
	"vTerminalGap": "수직 터미널 간격",
	"vTerminalTailLength": "수직 터미널 가로선 길이",
	"#Rows": "행 수",
	"#Cols": "열 수",
	"#Pins": "핀 수",
	"#DPins": "핀 수(D 면)",
	"#EPins": "핀 수(E 면)",
	"padShape": "패드 쉐이프",
	"RESISTOR": "저항기",
	"NONPOLARIZED_CAPACITOR": "콘덴서 - 편광되지 않음",
	"POLARIZED_CAPACITOR": "편광된 콘덴서",
	"DIODE": "다이오드",
	"FUSE": "퓨즈",
	"INDUCTOR": "인덕터",
	"POLARIZED_INDUCTOR": "편광된 인덕터",
	"NONPOLARIZED_INDUCTOR": "인덕터 - 편광되지 않음",
	"LRCCW": "맨 아래 왼쪽에서 시계 반대 방향",
	"LRCW": "맨 위 왼쪽에서 시계 방향",
	"ZZBT": "맨 아래 왼쪽에서 지그재그",
	"PIN_ONE": "핀 1",
	"CENTER_PADS": "패드 중심",
	"female": "암",
	"male": "수",
	"maleFemale": "수-암",
	"ROUND": "원형",
	"HEX": "16진수",
	"SQUARE": "사각형",
	"Round": "원형",
	"Square": "사각형",
	"RoundedSquare": "둥근 사각형",
	"Rectangle": "직사각형",
	"Black": "검은색",
	"Green": "초록색",
	"Blue": "파랑",
	"Yellow": "노란색",
	"Amber": "호박색",
	"Brown": "갈색",
	"Cyan": "하늘색",
	"Maroon": "밤색",
	"Grey": "회색",
	"Silver": "은색",
	"Purple": "자주색",
	"Red": "빨간색",
	"White": "흰색",
	"Most (A)": "대부분(A)",
	"Nominal (B)": "공칭(B)",
	"Least (C)": "최소(C)",
	"Most (M)": "대부분(M)",
	"Nominal (N)": "공칭(N)",
	"Least (L)": "최소(L)",
	"IC": "통합 회로(IC)",
	"PRECISION_INDUCTOR": "정밀도 인덕터",
	"LED": "LED",
	"THERMISTOR": "서미스터",
	"POLARIZED_DIODE": "다이오드",
	"VARISTOR": "배리스터",
	"FERRITE_BEAD": "페라이트 비드",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "칩",
	"SOD": "SOD",
	"MOLDED_BODY": "몰딩된 본체",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-캡",
	"CRYSTAL": "크리스탈",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "칩 배열, 2면 플랫/오목",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "칩 배열, 4면 플랫/오목",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "칩 배열, 2면 볼록",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "오실레이터 구석 오목",
	"OSCILLATOR_J_LEAD": "오실레이터 J-리드",
	"OSCILLATOR_L_BEND": "오실레이터 L-절곡부",
	"SOJ": "SOJ",
	"AXIAL": "깊이",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "핀 헤더(수) 직선",
	"PIN_HEADER_RA": "핀 헤더(수) 직각",
	"RECEPTACLE_HEADER_STRAIGHT": "리셉터클 헤더(암) 직선",
	"RECEPTACLE_HEADER_RA": "리셉터클 헤더(암) 직각",
	"SON_DFN": "SON(DFN)",
	"RADIAL_GENERIC": "반지름 일반(원형)",
	"RADIAL_LED": "반지름 LED(원형)",
	"CRYSTAL_HC49": "크리스탈(HC49)",
	"FEMALE_STANDOFF": "암 격리 절연기/스페이서",
	"MALE_FEMALE_STANDOFF": "수-암 격리 절연기",
	"SNAP_LOCK": "스냅 잠금",
	"Optional_D": "D(리드 스팬)",
	"Optional_D2": "D2(터미널 간격)",
	"Optional_L": "L(터미널 길이)",
	"CONCAVE": "오목",
	"FLAT": "플랫",
	"Oblong": "직사각형",
	"Collapsing_Ball": "축소되는 볼",
	"Non_Collapsing_Ball": "축소되지 않는 볼",
	"mountingHolePad": "마운팅 구멍 패드",
	"withVias": "Via 포함",
	"viasCount": "Via 개수",
	"viaDiameter": "Via 지름",
	"viaOffset": "구멍 중심에서 Via 간격띄우기",
	"viaThermalRelief": "Via 열 릴리프",
	"radialLedNote": "* c는 둥근 리드 쉐이프에 적용할 수 없습니다.",
	"lockHeight": "잠금 높이",
	"overrideLockDiameter": "잠금 지름 재지정",
	"lockDiameter": "잠금 지름",
	"overridePitch": "핀 피치 재지정",
	"bodyWidth": "본체 폭",
	"padWidth": "패드 폭",
	"plated": "도금",
	"ViaOffset": "구멍 중심에서 Via 간격띄우기",
	"holeDiameter": "구멍 지름",
	"snapLockNote1": "* 잠금 지름(E1)은 본체 지름(E)과 구멍 지름(b)을 기준으로 자동 계산됩니다. 그러나 잠금 지름을 재지정하여 사용자 값을 제공할 수 있습니다.",
	"snapLockNote2": "* 구멍 지름(b)은 본체 지름(E) 및 잠금 지름(E1)과 같지 않아야 합니다.",
	"leadWidth": "리드 폭",
	"leadThickness": "리드 두께",
	"boardThickness": "보드 두께",
	"error1": "구현되지 않았습니다.",
	"fabricationTolerance": "제작 공차", 
	"placementTolerance": "배치 공차",
	"CAPACITOR": "콘덴서 - 편광되지 않음",
	"CAPACITOR_NONPOLARIZED": "콘덴서 - 편광되지 않음",
	"CAPACITOR_NON_POLARIZED": "콘덴서 - 편광되지 않음",
	"FILTER": "필터", 
	"TRANSISTOR": "트랜지스터",
	"ecapNote": "* (D, D2, L)에서 선택적 치수를 선택합니다. 서로 다른 조합으로 다양한 외곽설정 패드 크기를 생성할 수 있습니다.",
	"maximum": "최대", 
	"nominal": "공칭", 
	"minimum": "최소",
	"bodyShape": "본체 쉐이프",
	"customSolderPaste": "사용자 땜납 붙여넣기",
	"thermalPad": "열 패드",
	"thermalPadLength": "열 패드 길이",
	"thermalPadWidth": "열 패드 폭",
	"RoundedRectangle": "둥근 직사각형",
	"extendedEdgeLength": "확장된 모서리 길이",
	"Generator": " 생성기",
	"axialNote": "* 핀 피치는 바디, 터미널 및 생산 가능 수준을 기반으로 자동으로 계산되어 외곽설정 IPC 규격에 맞도록 합니다.  그러나 IPC 규격이 아닌 외곽설정을 작성하기 위해 핀 피치를 재지정하여 사용자 값을 제공할 수 있습니다.",
	"baseHeight": "기준 높이",
	"CHIP_LED": "칩 LED",
	"updatePreview": "미리보기 업데이트",
	"Custom": "사용자화",
	"ledColorNote": "* 사용자 본체 색상에 대해 16진수 값을 입력합니다.",
	"customBodyColor": "사용자 본체 색상",							
	"lensShape": "렌즈 쉐이프",
	"domeDiameter": "돔 지름",
	"RECT_FLAT_TOP": "상단이 평평한 직사각형",
	"RECT_DOMED_TOP": "상단이 돔 형태인 직사각형",
	'customFootprint': '사용자 외곽설정',
	'customPadLength': '사용자 패드 길이',
	'customPadWidth': '사용자 패드 폭',
	'customPadGap': '사용자 패드 간 간격',
	'customOddPadWidth': '사용자 홀수 패드 폭',
	'customOddPadLength': '사용자 홀수 패드 길이',
	'customPadDiameter': '사용자 패드 지름',
	'customPadSpan1': '사용자 패드 스팬 1',
	'customPadSpan2' : '사용자 패드 스팬 2',
	'customPadPitch' : '사용자 패드 피치',
	'pinPitch1' : '핀 피치 1',
	'customPadGap1': '사용자 패드 간 간격 1',
	'Optional_g': 'g(사용자 패드 간격)',
	'Optional_p': 'p(사용자 패드 피치)',

	// JS Widgets
	"New_Library": "새 라이브러리",
	"Components": "구성요소",
	"Component": "구성요소",
	"Symbols": "기호",
	"Symbol": "기호",
	"Footprints": "외곽설정",
	"Footprint": "외곽설정",
	"Packages": "패키지",
	"Package": "패키지",
	"No": "아니오",
	"Name": "이름",
	"Pins": "핀",
	"Pads": "패드",
	"Description": "설명",
	"Variants": "변형",
	"Type": "유형",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "Library.io URN",
	"Library_io_Version": "Library.io 버전",
	"Link": "링크",
	"Rename": '이름바꾸기',
	"Edit_Description": '설명 편집',
	"Duplicate": '중복', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": '새 3D 모형 작성',
	"Attach_Copy_Existing_3D_Model": '기존 3D 모형의 사본 부착',
	"Edit": '편집',
	"Delete": '삭제',
	"Remove_From": '다음에서 제거',
	"Update_To_Latest": '최신으로 업데이트',
	"Create_New_Symbol": '새 기호 작성',
	"Create_New_Footprint": '새 외곽설정 작성',
	"Create_New_Component": '새 구성요소 작성',
	"Create_New_Package": '새 패키지 작성',
	"Delete_Package_Children_Warning": "이렇게 하면 이 외곽설정에서 사용하는 패키지도 삭제됩니다.",
	"No_Search_Results": "검색 결과 없음",
	"No_Library_Loaded": "라이브러리가 로드되지 않음",
	"Library_Stored_Fusion_Hub": "이 라이브러리는 your Fusion Hub에 저장됩니다.",
	"Library_Linked_Managed_Library": "이 라이브러리는 Library.io 관리되는 라이브러리에 링크되어 있습니다.",
	"Library_Local_Changes": "이 라이브러리에는 Library.io로 푸시되지 않은 변경 사항이 있습니다. 이 작업을 위해 '관리' 도구막대로 이동하십시오.",
	"Library_Remote_Changes": "이 라이브러리에는 Library.io에서 가져올 수 있는 새 업데이트가 있습니다. 이 작업을 위해 '관리' 도구막대로 이동하십시오.",
	"View_on_Library_io": "Library.io에서 보기",
	"Used_In": "사용 위치",
	"No_Selection": "선택 항목 없음",

	"No_Footprints": "외곽설정 없음",
	"No_Symbols": "기호 없음",
	"No_Components": "구성요소 없음",
	"No_Packages": "패키지 없음",

	"Package_Loading_Message": "패키지를 저장하고 업로드하는 동안 잠시 기다려 주십시오.",
	"Attributes": "속성",
	"View_Attributes": "뷰 속성",
	"Edit_Attributes": "뷰 속성",
	"Edit_Description": "설명 편집",
	
	"Use_Placeholder": "자리 표시자 사용",
	"Placeholder_Message": "외곽설정과 연관된 3D 모형이 없는 경우 자리 표시자 쉐이프를 사용합니다.",

	"Hub": "Hub",
	"New_Symbol": '새 기호',
	"New_Footprint": '새 외곽설정',
	"New_Component": '새 구성요소',
	"New_Package": '새 패키지',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Library.io 패키지 업데이트를 사용할 수 있습니다. 마우스 오른쪽 버튼을 클릭하고 업데이트를 선택하십시오.",
	"Package_Behind_Fusion": "Fusion 패키지 업데이트를 사용할 수 있습니다. 마우스 오른쪽 버튼을 클릭하고 업데이트를 선택하십시오.",
	"Package_Behind_Both": "패키지 업데이트를 사용할 수 있습니다. 마우스 오른쪽 버튼을 클릭하고 업데이트를 선택하십시오.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "자산 변경 사항을 가져오려면 라이브러리를 업데이트해야 합니다. 라이브러리를 업데이트하려면 관리' 도구막대를 사용하십시오.",
}